import { checkedIcon } from '@/public';
import Image from 'next/image';
import React from 'react';

const KeyTakeAway = ({ details }: any) => {
  return (
    <section className=' relative rounded-[20px] border border-[#dceaf8] bg-[#f2f9ff] p-[20px] pt-[65px] dark:border-[#334957] dark:bg-[#102636] lg:p-[35px] lg:pt-[65px]'>
      <span className='absolute left-[50%] top-[0px] translate-x-[-50%] translate-y-[-50%] whitespace-nowrap  rounded-[10px] bg-[#00b4b9] p-[8px_20px] text-[22px] font-semibold text-white lg:left-[165px]'>
        Key Takeaways
      </span>
      {details?.map((item: any, index: number) => (
        <ListItem item={item.item} key={`keytake:${index}`} />
      ))}
    </section>
  );
};

export default KeyTakeAway;

interface ListItemProps {
  item: string;
}

const ListItem: React.FC<ListItemProps> = ({ item }) => (
  <section className='mb-[20px] flex items-start gap-[12px] lg:gap-[20px] '>
    <Image src={checkedIcon} alt='' className='mt-[5px]' />
    <p className='text-[14px] font-medium dark:text-white lg:text-[17px]'>
      {item}
    </p>
  </section>
);
